<template>
  <div class="introduction-video">
    <div class="video-container">
      <!--开启侦探之路-->
      <transition name="start">
        <div class="start-container"  v-show="isStartShow">
          <div class="start-wrapper">
            <div class="start-image">
              <div></div>
            </div>

            <div class="start-btn" v-on:touchstart="playVideo">
              开启侦探之路
            </div>
          </div>
        </div>
      </transition>

      <!--
        iphone7 wechat test: playsinline 设置有效
        对于早期的ios需要设置： webkit-playsinline="true"
      -->
      <div class="video-wrapper">
        <div class="video-box">
          <video src="https://common.fcbox.com/app_manager/activity/detective/static/video.mp4" 
            x-webkit-airplay="true" 
            webkit-playsinline="true"
            playsinline
            x5-video-player-type="h5"></video>
        </div>  
      </div>
      
      <!--下一页按钮-->
      <transition name="fade">
        <div class="video-btn-container" v-show="isBtnShow">
          <div class="video-btn">
            <div class="video-btn-arrow"></div>
            <div class="video-btn-go"
                v-on:click="goNext"></div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  name: "introduction",
  data () {
    return {
      isStartShow: true,
      isBtnShow: false,
    }
  },
  methods: {
    playVideo () {
      let video = document.querySelector("video");
      this.isStartShow = false;
      video.play();
    },
    goNext () {
      this.$router.push("/suspect");
    }
  },
  mounted () {
    let video = document.querySelector("video");
    video.addEventListener("ended", () => {
      this.isBtnShow = true;
    });

    // propagation
    video.onclick = () => {
      let videoWrapper = document.querySelector(".video-wrapper");
      this.isStartShow = false;
      videoWrapper.style.opacity = 1;
      window.setTimeout(() => {
        video.play();
      }, 500); 
    }
  }
}
</script>

<style lang="scss">
@import "./video.scss";
</style>





// WEBPACK FOOTER //
// src/pages/video/video.vue